import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import LoginPage from '../components/GeneralViews/LoginPage.vue'

// Admin pages
import Overview from 'src/components/Dashboard/Views/Overview.vue'
import Fillings from 'src/components/Dashboard/Views/Fillings.vue'
import UserProfile from 'src/components/Dashboard/Views/UserProfile.vue'
import DownloadStats from 'src/components/Dashboard/Views/DownloadStats.vue'
import DeclarationsStats from 'src/components/Dashboard/Views/DeclarationsStats.vue'

const routes = [
  {
    name: 'Dashboard',
    path: '/',
    component: DashboardLayout,
    redirect: '/panel/wplaty'
  },
  {
    path: '/login',
    component: LoginPage
  },
  {
    path: '/panel',
    component: DashboardLayout,
    redirect: '',
    children: [
      {
        path: 'wplaty',
        name: 'Szacunkowe wpłaty 1,5%',
        component: Overview
      },
      {
        path: 'uruchomienia-wypelnienia',
        name: 'Uruchomienia i Wypełnienia',
        component: Fillings
      },
      {
        path: 'stats',
        name: 'Profil użytkownika',
        component: UserProfile
      },
      {
        path: 'statystyki-pobran',
        name: 'Statystyki pobrań',
        component: DownloadStats
      },
      {
        path: 'statystyki-deklaracji',
        name: 'Statystyki deklaracji',
        component: DeclarationsStats
      }
    ]
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js